import { track } from "../track";

export const trackAvatarCreateScs = (params: { avatar_id: string; gen_time: number }) =>
  track({ event: "avatar_create_scs", ...params });
